import { Box, Icon, IconOptions, ModalDialog, Spacer, Text } from '@jfs/ui-new'
import { useEffect } from 'react'
import { styles } from './styles'
export enum TimeOut {
  NEVER = -1,
  NOW = 1,
  ONE_SECOND = 1000,
  THREE_SECONDS = 3000,
  FIVE_SECONDS = 5000,
  SIX_SECONDS = 6000,
  TEN_SECONDS = 10000,
  FIFTEEN_SECONDS = 15000,
  THIRTY_SECONDS = 30000,
}
export enum ToastPosition {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  CENTER = 'CENTER',
  TOP_POSITIVE_ACTION_VIEW = 'TOP_POSITIVE_ACTION_VIEW',
}

export enum ToastType {
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
  ACTION_VIEW = 'ACTION_VIEW',
  POSITIVE_ACTION_VIEW = 'POSITIVE_ACTION_VIEW',
}

type ToastProps = {
  testID?: string
  hide: boolean
  type: keyof typeof ToastType
  position?: keyof typeof ToastPosition
  message?: string
  onDismiss?: () => void
  timeOut?: TimeOut
  onAction?: () => void
  bgColor?: any
  minWidthOfLeftBox?: number
  actionLabel?: string
}

export const Toast = ({
  type = ToastType.NEGATIVE,
  hide = false,
  message = '',
  position = ToastPosition.TOP,
  onDismiss,
  onAction,
  timeOut = TimeOut.FIVE_SECONDS,
  bgColor,
  minWidthOfLeftBox,
  actionLabel = 'View',
}: ToastProps) => {
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | any
    if (!hide) {
      timeout = setTimeout(onDismiss, timeOut)
    }
    return () => clearTimeout(timeout)
  }, [hide, onDismiss, timeOut])

  if (hide || message === '') {
    return null
  }
  const getIcon = () => {
    const Icons = {
      POSITIVE: 'ROUND_TICK',
      NEUTRAL: 'INFO',
      NEGATIVE: 'CLEAR',
      ACTION_VIEW: '',
      POSITIVE_ACTION_VIEW: '',
    }
    return Icons[type] as IconOptions
  }

  const showView = type === ToastType.ACTION_VIEW
  const positiveActionView = type === ToastType.POSITIVE_ACTION_VIEW
  // testID={testID} removed this while migration
  //FIXME: modal hides the toast and keyboard popup issue.
  const boxStyle = { ...styles[position].containerView, ...styles[type].bgColor }
  if (bgColor) {
    boxStyle.backgroundColor = bgColor
  }
  const getToast = () => {
    return (
      <Box {...boxStyle} underlayColor={'TRANSPARENT45'} testID={'toast-modal'}>
        <Box
          {...styles[type].leftBox}
          minWidth={minWidthOfLeftBox}
          testID={type === ToastType.NEGATIVE ? 'toast-error' : 'toast-success'}>
          {positiveActionView && (
            <Box flexDirection={'row'}>
              <Icon id={'ROUND_TICK'} color="WHITE" size="LARGE" />
              <Spacer size={8} direction={'horizontal'} />
            </Box>
          )}
          <Text {...styles[type].titleText} numberOfLines={2} textAlign={'left'} testID={'toast-modal-message'}>
            {message}
          </Text>
          <Spacer size={8} direction={'horizontal'} />
          {positiveActionView && (
            <Box onPress={onDismiss} testID="close-toast" underlayColor={'TRANSPARENT'}>
              <Icon id={'CLOSE'} color="WHITE" size="FONT_SIZE_MEDIUM" />
            </Box>
          )}
        </Box>
        <Box {...styles[type].actionContainer} testID="toast-action" onPress={onAction ?? onDismiss}>
          {!showView && <Icon id={getIcon()} color="WHITE" size="FONT_SIZE_2_EXTRA_LARGE" />}
          {(showView || positiveActionView) && (
            <Text
              {...styles[type].actionText}
              color={positiveActionView ? 'WHITE' : 'PRIMARY'}
              numberOfLines={1}
              textAlign={'right'}>
              {actionLabel}
            </Text>
          )}
        </Box>
      </Box>
    )
  }

  return (
    <ModalDialog
      children={getToast()}
      onDismiss={onDismiss}
      show={true}
      type={position === 'BOTTOM' ? 'Toast' : 'TopMenu'}
    />
  )
}
